/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 846:
/***/ ((module, exports, __webpack_require__) => {

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  ModuleContextHandler
} = __webpack_require__(495);
let appContextValue = {};
const updateAppContextByModule = (moduleName, moduleContext) => {
  appContextValue[moduleName] = moduleContext;
};
const getModuleState = moduleName => ModuleContextHandler.getState(appContextValue, moduleName);
const setModuleState = (moduleName, state) => {
  const currentModuleContext = ModuleContextHandler.setState(appContextValue, moduleName, state);
  updateAppContextByModule(moduleName, currentModuleContext);
};
const getModuleInstances = moduleName => ModuleContextHandler.getInstances(appContextValue, moduleName);
const addModuleInstance = (moduleName, instance) => {
  const currentModuleContext = ModuleContextHandler.addInstance(appContextValue, moduleName, instance);
  updateAppContextByModule(moduleName, currentModuleContext);
};
const removeModuleInstance = (moduleName, instance) => {
  const currentModuleContext = ModuleContextHandler.removeInstance(appContextValue, moduleName, instance);
  updateAppContextByModule(moduleName, currentModuleContext);
};
const mapInstancesToState = moduleName => {
  const instances = getModuleInstances(moduleName);
  const state = instances.map(instance => {
    const instanceProps = _objectSpread({}, instance.props);
    delete instanceProps.context;
    delete instanceProps.effectContext;
    return instanceProps;
  });
  return state;
};
const getAppContextValue = () => appContextValue;
const appContextFactory = function () {
  let contextValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : appContextValue;
  appContextValue = contextValue;
  return {
    getModuleState,
    setModuleState,
    getModuleInstances,
    addModuleInstance,
    removeModuleInstance,
    mapInstancesToState
  };
};
module.exports = appContextFactory;
exports = module.exports;
exports.appContextFactory = appContextFactory;
if (false) {}

/***/ }),

/***/ 270:
/***/ ((module, exports, __webpack_require__) => {

var REACT_ELEMENT_TYPE;
function _jsx(e, r, E, l) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = new Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const React = __webpack_require__(689);

/**
 * AppContext
 */
const AppContext = React.createContext({});

/**
 * AppProvider
 */
const AppProvider = _ref => {
  let {
    children,
    value
  } = _ref;
  return /*#__PURE__*/_jsx(AppContext.Provider, {
    value: _objectSpread({}, value)
  }, void 0, children);
};
const AppContextManager = {
  Context: AppContext,
  Provider: AppProvider
};
module.exports = AppContextManager;
exports = module.exports;
exports.AppContextManager = AppContextManager;

/***/ }),

/***/ 495:
/***/ ((module, exports) => {

const initializeModuleContextIfApplies = moduleContext => {
  if (!moduleContext) {
    const currentModuleContext = {
      state: null,
      instances: new Set()
    };
    return currentModuleContext;
  }
  return moduleContext;
};
const getState = (appContext, moduleName) => {
  const moduleContext = (appContext === null || appContext === void 0 ? void 0 : appContext[moduleName]) || null;
  if (moduleContext === null || !moduleContext.state) {
    return null;
  }
  if (Array.isArray(moduleContext.state) || moduleContext.state instanceof Set || typeof moduleContext.state === 'object') {
    return JSON.parse(JSON.stringify(moduleContext.state));
  }
  return moduleContext.state;
};
const setState = (appContext, moduleName, state) => {
  const moduleContext = (appContext === null || appContext === void 0 ? void 0 : appContext[moduleName]) || null;
  const currentModuleContext = initializeModuleContextIfApplies(moduleContext);
  currentModuleContext.state = state;
  return currentModuleContext;
};
const getInstances = (appContext, moduleName) => {
  const moduleContext = (appContext === null || appContext === void 0 ? void 0 : appContext[moduleName]) || null;
  return moduleContext !== null && moduleContext.instances ? [...moduleContext.instances] : null;
};
const addInstance = (appContext, moduleName, instance) => {
  const moduleContext = (appContext === null || appContext === void 0 ? void 0 : appContext[moduleName]) || null;
  const currentModuleContext = initializeModuleContextIfApplies(moduleContext);
  currentModuleContext.instances.add(instance);
  return currentModuleContext;
};
const removeInstance = (appContext, moduleName, instance) => {
  const moduleContext = (appContext === null || appContext === void 0 ? void 0 : appContext[moduleName]) || null;
  if (moduleContext !== null && moduleContext !== void 0 && moduleContext.instances) {
    moduleContext.instances.delete(instance);
    return moduleContext;
  }
  return null;
};
const ModuleContextHandler = {
  setState,
  addInstance,
  getState,
  getInstances,
  removeInstance
};
module.exports = ModuleContextHandler;
exports = module.exports;
exports.ModuleContextHandler = ModuleContextHandler;

/***/ }),

/***/ 84:
/***/ ((module, exports) => {

const canUseDOM = () => typeof window !== 'undefined' && window.document && window.document.createElement;
const isAnEmptyObject = obj => Object.keys(obj).length === 0;
module.exports = {
  canUseDOM,
  isAnEmptyObject
};
exports = module.exports;

/***/ }),

/***/ 781:
/***/ ((module, exports, __webpack_require__) => {

const {
  Component
} = __webpack_require__(689);
const PropTypes = __webpack_require__(580);
const {
  canUseDOM,
  isAnEmptyObject
} = __webpack_require__(84);
const appContextFactory = __webpack_require__(846);
const propsAreEquals = __webpack_require__(547);
function emitChange(props, context) {
  const {
    moduleName,
    reducePropsToState,
    handleStateChangeOnClient,
    mapStateOnServer
  } = props;
  const {
    mapInstancesToState,
    setModuleState
  } = context;
  let state = reducePropsToState(mapInstancesToState(moduleName));
  if (canUseDOM()) {
    handleStateChangeOnClient(state);
  } else if (mapStateOnServer) {
    state = mapStateOnServer(state);
  }
  setModuleState(moduleName, state);
}
const getContext = currentContext => !currentContext || isAnEmptyObject(currentContext) ? appContextFactory() : currentContext;
function initializeContextByInstance(props, context) {
  const {
    moduleName,
    children
  } = props;
  if (!context || isAnEmptyObject(context) || !moduleName || !children) {
    return;
  }
  const {
    addModuleInstance
  } = context;
  if (addModuleInstance) {
    addModuleInstance(moduleName, children);
    emitChange(props, context);
  }
}
function removeInstance(props, context) {
  const {
    moduleName,
    children
  } = props;
  if (!context || isAnEmptyObject(context) || !moduleName || !children) {
    return;
  }
  const {
    removeModuleInstance
  } = context;
  if (removeModuleInstance) {
    removeModuleInstance(moduleName, children);
    emitChange(props, context);
  }
}
class Effect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      context: getContext(props.context)
    };
    this.init();
  }
  shouldComponentUpdate(nextProps) {
    return !propsAreEquals(this.props, nextProps);
  }
  static getDerivedStateFromProps(props, _ref) {
    let {
      context
    } = _ref;
    return {
      context: getContext(context)
    };
  }
  componentDidUpdate() {
    const {
      context
    } = this.state;
    initializeContextByInstance(this.props, context);
  }
  componentWillUnmount() {
    const {
      context
    } = this.state;
    removeInstance(this.props, context);
  }
  init() {
    const {
      context
    } = this.state;
    initializeContextByInstance(this.props, context);
  }
  render() {
    const {
      children
    } = this.props;
    return children;
  }
}
Effect.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  context: PropTypes.any,
  children: PropTypes.node.isRequired,
  moduleName: PropTypes.string.isRequired,
  reducePropsToState: PropTypes.func.isRequired,
  handleStateChangeOnClient: PropTypes.func.isRequired,
  mapStateOnServer: PropTypes.func
};
module.exports = Effect;
exports = module.exports;
exports.Effect = Effect;
if (false) {}

/***/ }),

/***/ 366:
/***/ ((module, exports, __webpack_require__) => {

var REACT_ELEMENT_TYPE;
function _jsx(e, r, E, l) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = new Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const React = __webpack_require__(689);
const {
  AppContextManager
} = __webpack_require__(270);
const {
  Effect
} = __webpack_require__(781);
const {
  validateEffectProps
} = __webpack_require__(504);

/* eslint-disable class-methods-use-this */
function withEffect(moduleName, reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  validateEffectProps(moduleName, reducePropsToState, handleStateChangeOnClient, mapStateOnServer);
  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected wrapped component to be a React component.');
    }
    const WithEffect = props => /*#__PURE__*/_jsx(AppContextManager.Context.Consumer, {}, void 0, context => /*#__PURE__*/React.createElement(Effect, _extends({}, props, {
      context: (props === null || props === void 0 ? void 0 : props.effectContext) || context,
      moduleName: moduleName,
      handleStateChangeOnClient: handleStateChangeOnClient,
      mapStateOnServer: mapStateOnServer,
      reducePropsToState: reducePropsToState
    }), /*#__PURE__*/React.createElement(WrappedComponent, props)));
    WithEffect.displayName = "WithEffect(".concat(WrappedComponent.name || 'Component', ")");
    return WithEffect;
  };
}
module.exports = withEffect;
exports = module.exports;
exports.withEffect = withEffect;
exports.AppContextManager = AppContextManager;

/***/ }),

/***/ 547:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  deepEqual,
  shallowEqual
} = __webpack_require__(432);
const VALID_TYPES = ['bigint', 'boolean', 'number', 'string', 'undefined'];
const VALID_MODULE_NAMES = ['react-declarative-head'];
function getPrimitiveProps(props) {
  return Object.fromEntries(Object.entries(props).filter(_ref => {
    let [, value] = _ref;
    return value === null || VALID_TYPES.includes(typeof value);
  }));
}
function getChildrenWithPrimitiveProps(children) {
  if (!children) {
    return null;
  }
  const childrenProps = children.props || {};
  const {
    children: nextChildren
  } = childrenProps;
  const result = _objectSpread(_objectSpread({}, getPrimitiveProps(children)), {}, {
    props: getPrimitiveProps(childrenProps)
  });
  if (nextChildren !== null && nextChildren !== void 0 && nextChildren.props) {
    result.props.children = getChildrenWithPrimitiveProps(nextChildren);
  }
  return result;
}
function propsAreEquals(props, nextProps) {
  if (!VALID_MODULE_NAMES.includes(props.moduleName)) {
    return true;
  }
  const primitiveProps = getPrimitiveProps(props);
  const primitiveNextProps = getPrimitiveProps(nextProps);
  const children = getChildrenWithPrimitiveProps(props.children);
  const nextChildren = getChildrenWithPrimitiveProps(nextProps.children);
  return shallowEqual(primitiveProps, primitiveNextProps) && deepEqual(children, nextChildren);
}
module.exports = propsAreEquals;

/***/ }),

/***/ 504:
/***/ ((module, exports) => {

const validateEffectProps = (moduleName, reducePropsToState, handleStateChangeOnClient, mapStateOnServer) => {
  if (typeof moduleName !== 'string') {
    throw new Error('Expected moduleName to be a string that identifies the module.');
  }
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }
};
module.exports = validateEffectProps;
exports = module.exports;
exports.validateEffectProps = validateEffectProps;

/***/ }),

/***/ 432:
/***/ ((module) => {

"use strict";
module.exports = require("fast-equals");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(366);
/******/ 	module.exports.withEffect = __webpack_exports__;
/******/ 	
/******/ })()
;